<template>
    <div>
        <h1>
            <font-awesome-icon icon="users"/>
            {{$t('global.menu.contacts')}}
        </h1>
        <div class="lead mb-4">{{ $t('contacts.description') }}</div>
        <div class="mb-4">
            <router-link class="btn btn-lg btn-primary" :to="{ name: 'ContactAdd' }">{{$t('contacts.list.add')}}</router-link>
            <button class="btn btn-lg btn-light" @click="getContacts()">{{$t('contacts.list.refresh')}}</button>
        </div>
        <div>
            <div class="row" v-if="items">
                <router-link class="col-lg-4 col-md-6 mb-4" v-for="(item, index) in items" :key="index"
                             :to="{name: 'ContactShow', params: { id: item['id']>0?item['id']:'' }}">
                    <div class="card h-100" :class="{'border': item['id'] === highlight, 'border-primary': item['id'] === highlight}">
                        <div class="text-white text-capitalize card-body d-flex align-items-center">
                            {{ item['alias']}}
                        </div>
                    </div>
                </router-link>
            </div>
            <div v-if="items.length == 0" class="row mt-2">
                <div class="col-md-12">
                    <div class="alert alert-warning" role="alert">
                        {{ $t('contacts.list.empty') }}
                    </div>
                </div>
            </div>
        </div>
        <b-modal ok-only @hidden="hidePairModal" ref="loginModalRef" id="loginModalRef"
                 v-model="showModal" size="lg" hide-footer>
            <div slot="modal-title">
                <button class="btn btn-secondary" @click="setPairMethod(null)" v-if="pairMethod!==null">
                    <font-awesome-icon icon="chevron-left"/>
                </button>
                {{$t('contacts.addModal.title')}}
            </div>
            <router-view name="modal"/>
        </b-modal>
        <pagination v-bind:view="view" v-bind:getPage="getContacts"></pagination>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Pagination from '../app/Pagination';

export default {
    data() {
        return {
            showModal: this.$route.meta.showModal,
        };
    },
    watch: {
        '$route.meta'({showModal}) {
            this.showModal = showModal;
            this.setPairMethod(null);
        },
    },
    props: {
        highlight: Number,
        showBackLink: {
            type: Boolean,
            default: false,
        },
    },
    components: {Pagination},
    computed: mapGetters({
        items: 'contact/list/items',
        loading: 'loading/loading/loading',
        view: 'contact/list/view',
        pairMethod: 'contact/pair/method',
    }),
    methods: {
        ...mapActions({
            getContacts: 'contact/list/getItems',
            setPairMethod: 'contact/pair/setMethod',
        }),
        hidePairModal: function () {
            this.getContacts();
            this.$router.push({name: 'ContactList'});
        },
    },
    created() {
        this.getContacts();
    },
    beforeDestroy() {
        this.$store.dispatch('contact/list/reset');
    },
};
</script>



// WEBPACK FOOTER //
// src/components/contact/List.vue